// @flow
export default {
  login: {
    marginRight: '8px',
    textDecoration: 'none'
  },
  color: (color: string) => ({
    fontSize: '1rem',
    color
  })
}
